<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Farmacie" header-tag="header">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Farmacia</label>
                    <span> {{ jsonData.farmacia }}</span>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Cap</label>
                    <span> {{ jsonData.cap }}</span>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Codice Struttura</label>
                    <span> {{ jsonData.codiceStruttura }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Comune</label>
                    <span> {{ jsonData.denominazioneComune }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Frazione</label>
                    <span> {{ jsonData.frazione }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Id-Agenda</label>
                    <span> {{ jsonData.idAgenda }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Partita IVA</label>
                    <span>{{ jsonData.partitaIva }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Telefono</label>
                    <span>{{ jsonData.telefono }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Via</label>
                    <span>{{ jsonData.via }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Titolare</label>
                    <span>{{ jsonData.titolare }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Email</label>
                    <span>{{ jsonData.email }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Utenti Associati" header-tag="header">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Utenti Associati</h6>
                    <b-button size="sm" variant="danger" @click="onDeleteAssociazioneTutti" :disabled="items.length === 0">
                        <b-icon icon="people-fill" aria-hidden="true"></b-icon>
                        Dissocia Tutti
                    </b-button>
                </div>
            </template>
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                <!-- <template #cell(firstname)="row">
                        <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                    </template> -->
                <template #cell(actions)="row">
                    <b-button variant="outline-danger" @click="onDeleteAssociazione(row.item)">
                        <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                        Dissocia
                    </b-button>
                </template>
            </b-table>
        </b-card>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import axios from "axios";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            id: "-1",
            jsonData: {
                farmacia: null,
                cap: null,
                codiceStruttura: null,
                comune: null,
                frazione: null,
                idAgenda: null,
                partitaIva: null,
                telefono: null,
                via: null,
                titolare: null,
                email: null,
            },
            items: [],
            pathResource: "/farmacie",
            pathResourceFarmacieUtenti: "/farmacieutenti",
            currentPage: 1,
            perPage: 1000,
            fields: [
                {
                    label: "Gruppo",
                    key: "profiloUtente",
                    sortable: true,
                    thStyle: "width: 12rem",
                },
                {
                    label: "Username",
                    key: "usernameUtente",
                    sortable: true,
                    thStyle: "width: 12rem",
                },
                {
                    label: "",
                    key: "actions",
                    tdClass: "text-right",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        this.id = this.$route.params.id;
        me.loadData(this.id);
        me.loadDataFarmacieUtenti(this.id);
    },
    methods: {
        loadData(id) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + id, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            error;
            let me = this;
            me.$emit("afterLoadData");
        },
        loadDataFarmacieUtenti(id) {
            this.loadDataResources(this.pathResourceFarmacieUtenti, { idFarmacia: id }, this.loadDataFarmacieUtentiSuccess, null);
        },

        loadDataFarmacieUtentiSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
        },
        onDeleteAssociazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
                    title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteAssociazione(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceFarmacieUtenti + "/";
            axios
                .delete(link + item.id)
                .then((response) => {
                    console.log(response);
                    me.showModalLoading = false;
                    me.loadData(this.id);
                    me.loadDataFarmacieUtenti(this.id);
                })
                .catch((error) => {
                    console.log(error);
                    me.showModalLoading = false;
                });
        },

        onDeleteAssociazioneTutti() {
            let me = this;

            this.$bvModal
                .msgBoxConfirm("Sei sicuro di voler dissociare TUTTI gli utenti da questa farmacia?", {
                    title: "Conferma Dissociazione Globale",
                    buttonSize: "sm",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    okTitle: "SI, Dissocia Tutti",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAllAssociazioni();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async deleteAllAssociazioni() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceFarmacieUtenti + "/";

            try {
                for (let i = 0; i < me.items.length; i++) {
                    axios.delete(link + me.items[i].id);
                }
                me.showModalLoading = false;
                me.loadDataFarmacieUtenti(me.$route.params.id);
            } catch (error) {
                console.error("Errore durante l'eliminazione massiva:", error);
                me.showModalLoading = false;
            }
        },
    },
};
</script>
